module.exports = __webpack_public_path__ + "static/img/aboutTop04.559f6ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutTop04.png
// module id = PSNH
// module chunks = 1